import { api } from 'src/services/api'

export type Infraction = {
  id: string
  status: string
  analysis_status: string
  analysis_date: string
  analysis_description: string
  situation_type: string
  transaction_id: string
  amount: number
  infraction_date: string
  payer_name: string
  payer_tax_id: string
  refund: {
    status: string
    analysis_status: string
    transaction_id: string
    refunded_amount: number
    refund_date: string
    rejection_reason: string
  }
  user: {
    name: string
  }
}
type Response = {
  id: string
  userId: string
  transactionId: string
  infractionId: string
  status: string
  isDone: boolean
  data: {
    id: string
    user: {
      name: any
    }
    amount: number
    refund: {
      status: any
      refund_date: any
      transaction_id: any
      analysis_status: any
      refunded_amount: any
      rejection_reason: any
    }
    status: string
    payer_name: string
    contested_at: any
    payer_tax_id: string
    analysis_date: any
    situation_type: string
    transaction_id: string
    analysis_status: string
    infraction_date: string
    analysis_description: string
    infraction_description: string
  }
  created_at: string
  updated_at: string
}[]

export async function listInfractions() {
  try {
    const tokenbf = localStorage.getItem('@backoffice:token')
    const token = localStorage.getItem('@stricv2:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    if (user?.virtual_account_id) {
      const response = await api.get<Response>(
        `/graphic/infractions/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } else {
      const response = await api.get<Response>(`/graphic/infractions/admin`, {
        headers: {
          Authorization: `Bearer ${tokenbf}`,
        },
      })
      return response.data
    }
  } catch (error) {
    console.error(error)
  }
}
